import { experience } from "../data/profile";
import "../professional.css";

export function ProfessionalSections() {
  return (
    <>
      <section
        id="experience"
        className="experience-section wrap"
        aria-labelledby="experience-heading"
      >
        <p className="micro">EXPERIENCE</p>
        <h2 id="experience-heading">The work behind the apps.</h2>
        <div className="experience-list">
          {experience.map((item) => (
            <article className="experience-entry" key={item.company}>
              <p className="experience-date">{item.date}</p>
              <div>
                <h3>{item.role}</h3>
                <p className="experience-company">
                  {item.company} <span>· {item.location}</span>
                </p>
                <p className="experience-description">{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
      <section
        id="about"
        className="about-section wrap"
        aria-labelledby="about-heading"
      >
        <div className="about-copy">
          <p className="micro">ABOUT</p>
          <h2 id="about-heading">
            An engineer who
            <br />
            cares about the interface.
          </h2>
          <p>
            I’m Kevin Hernandez-Nino, a computer engineer with experience in
            integrated systems and software. My independent apps give me room to
            work on the whole product: how it looks, how it behaves, and how it
            keeps a reliable record.
          </p>
          <p className="about-education">
            BS, Computer Engineering · Mathematics minor
            <br />
            <span>Walla Walla University, 2019–2023</span>
          </p>
        </div>
        <div id="capabilities" className="about-toolkit">
          <h3>What I work with</h3>
          <dl>
            <div>
              <dt>Native apps</dt>
              <dd>Swift, SwiftUI, Core Data</dd>
            </div>
            <div>
              <dt>Connected experiences</dt>
              <dd>WidgetKit, ActivityKit, WatchConnectivity</dd>
            </div>
            <div>
              <dt>Web</dt>
              <dd>React, TypeScript, CSS</dd>
            </div>
            <div>
              <dt>Engineering</dt>
              <dd>Systems integration, testing, technical documentation</dd>
            </div>
          </dl>
        </div>
      </section>
    </>
  );
}
